import { valueID_No, valueID_Yes, valueID_YesNo } from '@app/hcs-shared';
import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { currentTimeMillis, Hour, ThisShouldNotHappenException } from '@nu-art/ts-common';
const cpVarId = '35f333d8481bea7133eaac673be8c738';
const getRandomValue = (variable) => {
    if (variable.valueId === valueID_YesNo)
        return Math.random() > 0.5 ? valueID_Yes : valueID_No;
    const values = ModuleFE_Value.getRelatedValues(variable);
    if (!values)
        throw new ThisShouldNotHappenException('WTF');
    const index = Math.floor(Math.random() * values.values.length - 1);
    return values.values[index]._id;
};
const generateAttributes = (timestamp, currentEncounter) => {
    const allAttributeInstances = ModuleFE_Variable.cache.filter(item => item.type === 'attribute-instance' && item.parents.variableId === cpVarId);
    const startIndex = Math.floor(Math.random() * allAttributeInstances.length - 1);
    const attributes = allAttributeInstances.slice(startIndex, startIndex + 3);
    return attributes.map(attribute => {
        return {
            variable: attribute,
            metadata: {},
            results: [{
                    timestamp,
                    currentEncounter,
                    valueId: getRandomValue(attribute),
                }],
        };
    });
};
const generateEnumFindingTest = (results) => {
    const variable = ModuleFE_Variable.cache.unique(cpVarId);
    const result = {
        variable,
        metadata: {
            source: results[0].source,
        },
        results: results.map((resultProps, index) => {
            const result = {
                valueId: getRandomValue(variable),
                currentEncounter: resultProps.currentEncounter,
                timestamp: currentTimeMillis() - (index * Hour),
            };
            if (resultProps.generateAttributes)
                result.attributes = generateAttributes(result.timestamp, result.currentEncounter);
            return result;
        })
    };
    return result;
};
export const FindingTooltipEnumTests = () => [
    {
        label: 'Single Value',
        data: generateEnumFindingTest([
            { currentEncounter: true, source: 'fhir' },
        ])
    },
    {
        label: 'Single Value W/ Attributes',
        data: generateEnumFindingTest([
            { currentEncounter: true, generateAttributes: true, source: 'fhir' },
        ])
    },
    {
        label: 'Multi Value',
        data: generateEnumFindingTest([
            { currentEncounter: true, source: 'advisor' },
            { currentEncounter: true, source: 'advisor' },
            { currentEncounter: true, source: 'fhir' },
        ])
    },
    {
        label: 'Multi Value W/ Attributes',
        data: generateEnumFindingTest([
            { currentEncounter: true, generateAttributes: true, source: 'advisor' },
            { currentEncounter: true, source: 'fhir' },
            { currentEncounter: true, generateAttributes: true, source: 'fhir' },
        ])
    },
    {
        label: 'Single Value - Previous Encounter',
        data: generateEnumFindingTest([
            { currentEncounter: false, source: 'fhir' },
        ])
    },
    {
        label: 'Single Value - Previous Encounter W/ Attributes',
        data: generateEnumFindingTest([
            { currentEncounter: false, source: 'fhir' },
        ])
    },
    {
        label: 'Multi Value - W/ Previous Encounter',
        data: generateEnumFindingTest([
            { currentEncounter: true, source: 'advisor' },
            { currentEncounter: true, source: 'fhir' },
            { currentEncounter: false, source: 'fhir' },
        ])
    },
    {
        label: 'Mega Mix',
        data: generateEnumFindingTest([
            { currentEncounter: true, generateAttributes: true, source: 'advisor' },
            { currentEncounter: true, source: 'advisor' },
            { currentEncounter: true, generateAttributes: true, source: 'fhir' },
            { currentEncounter: false, generateAttributes: true, source: 'fhir' },
            { currentEncounter: false, source: 'fhir' },
        ])
    }
];
//# sourceMappingURL=enumerated.js.map